import { Logger, logger } from './logger'

export { Logger, logger }

// mock console with our logger
globalThis.console = new Logger('console') as unknown as Console
